export const environment = {
  user: {},
  version: '0.0.1',
  production: false,
  //baseUrl: 'http://localhost:8080/api',
  //baseUrl: 'http://10.10.30.80:8081/api',
  // baseUrl: 'http://10.201.16.51:8080/api',
   baseUrl: 'https://app.happyreport.store/api',
  //baseUrl: 'https://app.happyreport.store/insight/api',
  scheme: 'localhost:/',
  language: '',
};
